/**
 * Los mismos doce tonos que el calendario (spec 015 · FR-020).
 * Aquí no hay tabla: se reparte por id para que no cambie al recargar.
 */
export const PALETA_HORARIOS = [
    '#38bdf8',
    '#f472b6',
    '#4ade80',
    '#a78bfa',
    '#fb923c',
    '#2dd4bf',
    '#e879f9',
    '#84cc16',
    '#60a5fa',
    '#f9a8d4',
    '#34d399',
    '#c084fc',
] as const

export function colorDeProfesional(id: number): string {
    return PALETA_HORARIOS[Math.abs(id) % PALETA_HORARIOS.length] as string
}

/** Solo `#rrggbb`. Lo que acaba en un `style` no puede ser texto libre. */
export function normalizarHex(v: string): string | null {
    const t = v.trim().toLowerCase()
    return /^#[0-9a-f]{6}$/.test(t) ? t : null
}

export function colorConAlfa(hex: string, alfa: number): string {
    const m = /^#([0-9a-f]{6})$/i.exec(hex.trim())
    if (!m?.[1]) return hex
    const n = Number.parseInt(m[1], 16)
    const r = (n >> 16) & 255
    const g = (n >> 8) & 255
    const b = n & 255
    return `rgba(${r}, ${g}, ${b}, ${alfa})`
}
